import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgXClose = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19 5L5 19M5 5L19 19",
		stroke: "#DFCBF5",
		strokeOpacity: .4,
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgXClose;
